<template>
  <div>
    <div class="screen no-screen-border">
      <!-- start flexbox-container -->
      <div class="flexbox-container">
        <!-- TV Left Column-->
        <div class="screen-left">
          <div class="header">
            <div class="ticket-label">
              {{ $t('ticket') }}
            </div>
            <div class="table-label">
              {{ $t('desk') }}
            </div>
          </div>
          <audio
            id="audio"
            ref="plim"
          ><source
            src="~@/assets/media/plim.mp3"
            type="audio/mpeg"
          >
          </audio>
          <div class="queues-tickets-list">
            <queue
              v-for="ticket in tickets"
              :id="String('queue-' + ticket.letter)"
              :key="ticket.letter"
              :letter="ticket.letter"
              :desk="Number(ticket.desk)"
              :number="Number(ticket.number)"
              :class="{ 'first-call': firstCallAnimation(ticket.letter), 'calling-again': callingAgainAnimation(ticket.letter) }"
              class="queue"
            />
          </div>
        </div>

        <!-- TV Right Column-->
        <div class="screen-right">
          <!-- featured image -->
          <div class="status">
            <span class="day"> {{ date }} </span>
            <span class="hours"> {{ time }} </span>
          </div>

          <div
            v-for="featuredEntry in news"
            :key="featuredEntry.id"
            :class="{ visible: featuredEntry.id === currentNewsEntry.id }"
            class="latest-news featured"
          >
            <img
              :src="featuredEntry.img"
              class="featured-image"
            >
            <div class="featured-content">
              <span class="featured-content__label">Notícias</span>
              <!-- eslint-disable vue/no-v-html -->
              <div
                class="featured-content__title"
                v-html="featuredEntry.title"
              />
              <!-- eslint-enable vue/no-v-html -->
            </div>
          </div>
        </div>
      </div>
      <!-- end flexbox-container -->
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import Queue from '@/components/Queue'

export default {
  components: {
    Queue
  },
  props: {
    serviceID: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: false,
      default: undefined
    },
    socket: {
      type: Object,
      required: true
    }

  },
  data () {
    return {
      hour: 15,
      minutes: 46,
      weekDay: 'Quarta',
      day: 3,
      month: 'Outubro',
      year: 2018,
      date: null,
      time: null,
      currentTicket: {},
      clock: null,
      newsPointer: 0,
      timeout: null
    }
  },
  computed: {
    ...mapState([
      'currentTickets',
      'news'
    ]),
    tickets () {
      let tickets = Object.keys(this.currentTickets).map((letter) => {
        return {
          ...this.currentTickets[letter]
        }
      })
      tickets.sort((a, b) => {
        if (a.letter < b.letter) {
          return -1
        } else if (a.letter > b.letter) {
          return 1
        } else {
          return 0
        }
      })
      return tickets
    },
    currentNewsEntry () {
      return this.news[this.newsPointer]
    }
  },
  created () {
    this.socket.on('connect', () => {
      this.socket.emit('register-device', {
        service: this.serviceID
      })
    })
    this.socket.on('ticket-call', (ticket) => {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = this.currentTicket = {}
      }
      this.currentTicket = ticket
      this.fetchCurrentTickets(this.serviceID)
      try {
        this.play()
      } catch (error) {
        console.log(error)
      }
      this.timeout = setTimeout(() => {
        this.currentTicket = {}
      }, 2000)
    })
    moment.locale('pt')
    setInterval(this.updateDateAndTime, 10000)
    this.updateDateAndTime()
    this.fetchNews()
    setInterval(this.changeCurrentNewsEntry, 10000)
  },
  beforeDestroy () {
    this.socket.disconnect()
  },
  methods: {
    updateDateAndTime () {
      this.date = moment().format('dddd, D MMMM YYYY')
      this.time = moment().format('LT')
    },
    ...mapActions([
      'fetchCurrentTickets',
      'fetchNews'
    ]),
    async play () {
      var audio = this.$refs.plim
      audio.pause()
      audio.currentTime = 0
      audio.play()
    },
    firstCallAnimation (letter) {
      return (this.currentTicket.letter === letter) && (!this.currentTicket.recall)
    },
    callingAgainAnimation (letter) {
      return (this.currentTicket.letter === letter) && (this.currentTicket.recall)
    },
    changeCurrentNewsEntry () {
      this.newsPointer++
      this.newsPointer = this.newsPointer % this.news.length
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'Klavika-Light-New';
  src:
    url('~@/assets/fonts/Klavika-Light/Klavika-Light.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/Klavika-Light/Klavika-Light.otf')  format('opentype'),
    url('~@/assets/fonts/Klavika-Light/Klavika-Light.woff') format('woff'),
    url('~@/assets/fonts/Klavika-Light/Klavika-Light.ttf')  format('truetype'),
    url('~@/assets/fonts/Klavika-Light/Klavika-Light.svg#Klavika-Light') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Klavika-Regular-New';
  src:
    url('~@/assets/fonts/Klavika-Regular/Klavika-Regular.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/Klavika-Regular/Klavika-Regular.otf')  format('opentype'),
    url('~@/assets/fonts/Klavika-Regular/Klavika-Regular.woff') format('woff'),
    url('~@/assets/fonts/Klavika-Regular/Klavika-Regular.ttf')  format('truetype'),
    url('~@/assets/fonts/Klavika-Regular/Klavika-Regular.svg#Klavika-Regular') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Klavika-Medium-New';
  src:
    url('~@/assets/fonts/Klavika-Medium/Klavika-Medium.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/Klavika-Medium/Klavika-Medium.otf')  format('opentype'),
    url('~@/assets/fonts/Klavika-Medium/Klavika-Medium.woff') format('woff'),
    url('~@/assets/fonts/Klavika-Medium/Klavika-Medium.ttf')  format('truetype'),
    url('~@/assets/fonts/Klavika-Medium/Klavika-Medium.svg#Klavika-Medium') format('svg');
  font-weight: normal;
  font-style: normal;
}

.ticket-label,
.ticket {
  width: 270px;
}

.table-label,
.table {
  margin-left: 6rem;
  width: 200px;
}
// Imports with Fontspring @Font-Face Syntax

.screen {
  // TV Resolution
  box-sizing: content-box;
  width: 120rem;
  height: 67.5rem;
  overflow: hidden;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.flexbox-container {
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

// /* Left side */
.screen-left {
  box-sizing: border-box;
  background-color: #fff;
  color: #100a24;
  padding: 60px 80px;
  width: 44.375rem;
}

.screen-left .header {
  font-family: Klavika-Regular-New, sans-serif;
  font-size: 60px;
  margin-bottom: 70px;
  display: flex;
  text-align: center;
}

.queues-tickets-list {
  font-family: Klavika-Medium-New, sans-serif;
  font-size: 80px;
  display: flex;
  flex-direction: column;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
}

.queue {
  margin-bottom: 5rem;
  display: flex;
  align-items: center;
}

// selects everything in a list divisible by 4
.queues-tickets-list .queue:nth-last-child(4n):first-child {
  margin-top: 1.25rem;
}

.queues-tickets-list .queue:nth-last-child(4n):first-child,
.queues-tickets-list .queue:nth-last-child(4n):first-child ~ .queue {
  margin-bottom: 8rem;
}

// selects everything in a list divisible by 5
.queues-tickets-list .queue:nth-last-child(5n):first-child,
.queues-tickets-list .queue:nth-last-child(5n):first-child ~ .queue {
  margin-bottom: 4rem;
}

// selects everything in a list divisible by 6
.queues-tickets-list .queue:nth-last-child(6n):first-child {
  margin-top: -3rem;
}

.queues-tickets-list .queue:nth-last-child(6n):first-child,
.queues-tickets-list .queue:nth-last-child(6n):first-child ~ .queue {
  margin-bottom: 3.5rem;
}

// ===

// Right side
.screen-right {
  box-sizing: border-box;
  background-color: #140a2b;
  color: #fff;
  width: 75.625rem;

  // width: 63%;
  position: relative;
  overflow: hidden;
}

.latest-news .featured-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 110%;
  height: 110%;
  object-fit: cover;
  opacity: 0;
  visibility: hidden;
  transition: all 2s ease 0s;
}

.latest-news .featured-content {
  position: absolute;
  bottom: 3.75rem;
  left: 8.75rem;
  opacity: 0;
  visibility: hidden;
  transform: translateY(8%);
  transition: all 1s ease-in-out 0s;
}

.latest-news.visible .featured-image {
  opacity: 0.1;
  visibility: visible;
}
.latest-news.visible .featured-content {
  opacity: 1;
  visibility: visible;
  transform: none;
  transition: all 1.2s ease-in-out 1s;
}

.status {
  height: 6.25rem;
  text-transform: uppercase;
  background-color: rgba(16, 10, 36, 0.4);
  padding-right: 7rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
  position: relative;
  z-index: 2;
}

.status .day {
  font-family: Klavika-Light-New, sans-serif;
  font-size: 1.625rem;
  opacity: 0.9;
}
.status .hours {
  font-size: 2.875rem;
  padding-left: 2.5rem;
  font-family: Klavika-Regular-New, sans-serif;
}

.featured-content__label {
  background-color: #009de0;
  padding: 10px 12px 6px;
  font-size: 20px;
  font-family: Klavika-Medium-New, sans-serif;
  text-transform: uppercase;
  display: inline;
}

.featured-content__title {
  max-width: 900px;
  margin-top: 56px;
  font-size: 60px;
  font-family: Klavika-Medium-New, sans-serif;
  line-height: 1.3;
  margin-bottom: 2rem;
}

// /* Calling animations */
@keyframes flash {
  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}

@keyframes ticket {
  from {
    background-color: #009de0;
  }
  to {
    background-color: #100a24;
  }
}

@keyframes table {
  from {
    color: #009de0;
  }
  to {
    color: #100a24;
  }
}
</style>
